import {openDB} from 'idb';

export default {
    dbPromise: null,
    version: 2,
    create: function(){
        const self = this;
        return this.dbPromise = openDB('prixo-badge-store', this.version, {
          upgrade(db) {
            if (!db.objectStoreNames.contains('sync-badges')) {
              db.createObjectStore('sync-badges', { keyPath: 'id' });
            }
            if (!db.objectStoreNames.contains('config')) {
              db.createObjectStore('config', { keyPath: 'key' });
            }
          },
          // A newer version wants to open: close and reload, so this page
          // never keeps working on a closed connection.
          blocking() {
            self.dbPromise.then(db => db.close()).then(() => window.location.reload());
          },
        });
    },
    getConfig: function (key) {
        return this.dbPromise.then(db => db.get('config', key)).then(row => row ? row.value : null);
    },
    setConfig: function (key, value) {
        return this.dbPromise.then(db => db.put('config', { key: key, value: value }));
    },
    writeData: function (st, data) {
        return this.dbPromise
            .then(function (db) {
                var tx = db.transaction(st, 'readwrite');
                var store = tx.objectStore(st);
                store.put(data);
                return tx.done;
            });
    },
    writeMultiple: function (st, data) {
        for (let i = 0; i < data.length; i++) {
            const element = data[i];
            this.writeData(st, element);
        }
    },
    readAllData: function(st) {
        return this.dbPromise
            .then(function (db) {
                var tx = db.transaction(st, 'readonly');
                var store = tx.objectStore(st);
                return store.getAll();
            });
    },
    getDataById: function (st, id) {
        return this.dbPromise
            .then(function (db) {
                var tx = db.transaction(st, 'readonly');
                var store = tx.objectStore(st);
                return store.get(id);
            });
    },
    clearAllData: function(st) {
      return this.dbPromise
        .then(function(db) {
          var tx = db.transaction(st, 'readwrite');
          var store = tx.objectStore(st);
          store.clear();
          return tx.done;
        });
    },
    deleteItemFromData: function(st, id) {
      return this.dbPromise
        .then(function(db) {
          var tx = db.transaction(st, 'readwrite');
          var store = tx.objectStore(st);
          store.delete(id);
          return tx.done;
        })
        .then(function() {
          console.log('Item deleted!');
        });
    }
}